export const isLocalStorageUsable = (): boolean => {
  try {
    return Boolean(window.localStorage);
  } catch {
    return false;
  }
};
